import { useMutation } from '@apollo/client';
import { Form, Modal, Select } from 'antd';
import React, { useState } from 'react';
import { DUPLICATE_ENV_KEY_VALUE } from '../graphql/Mutations';

export default function DuplicateKeyValueModal({
  visible,
  setVisible,
  envRecords = [],
  selectedKeys = [],
  refetchEnvKeyValueData,
  setSelectedRowKeys,
}) {
  const [form] = Form.useForm();
  const [sourceBranch, setSourceBranch] = useState(null);

  const targetOptions = envRecords?.[0]?.environmentKeyValues?.filter(
    (env) => env?.environmentId !== sourceBranch,
  );

  const [duplicateValue] = useMutation(DUPLICATE_ENV_KEY_VALUE, {
    onCompleted() {
      refetchEnvKeyValueData();
      setSelectedRowKeys([]);
      setVisible(false);
      form?.resetFields();
    },
    onError() {},
  });

  const onFinish = (values) => {
    const { sourceId, targetIds } = values;
    duplicateValue({
      variables: {
        data: {
          keyIds: selectedKeys,
          sourceId,
          targetIds,
        },
      },
    });
  };

  return (
    <Modal
      open={visible}
      centered
      title="Copy value to another ENV"
      onCancel={() => {
        setVisible(false);
        setSelectedRowKeys([]);
        form?.resetFields();
      }}
      onOk={() => form?.submit()}
      okText="Copy"
    >
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item
          label="Source Env"
          name="sourceId"
          rules={[
            {
              required: true,
              message: 'Please enter key name',
            },
          ]}
        >
          <Select
            className="selection"
            placeholder="Select Source Env"
            options={envRecords?.[0]?.environmentKeyValues?.map((env) => ({
              label: env?.environmentName,
              value: env?.environmentId,
            }))}
            onSelect={(value) => setSourceBranch(value)}
          />
        </Form.Item>
        <Form.Item
          label="Target Env"
          name="targetIds"
          rules={[
            {
              required: true,
              message: 'Please enter key name',
            },
          ]}
        >
          <Select
            className="selection"
            placeholder="Select Target Env"
            mode="multiple"
            options={targetOptions?.map((env) => ({
              label: env?.environmentName,
              value: env?.environmentId,
            }))}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}
